import Ai from './Ai';

export default Ai;
